import type { PinRequest } from "@/auth/pin";

interface Props {
  pin: PinRequest | null;
  pairing: boolean;
  error: string | null;
  onSignIn: () => void;
}

export function SignIn({ pin, pairing, error, onSignIn }: Props) {
  if (pin !== null) {
    return (
      <div className="state">
        <strong>Enter this code</strong>
        <p>
          Open <b>simkl.com/pin</b> on any device and type the code below. This screen continues on
          its own.
        </p>
        <span className="code">{pin.userCode}</span>
      </div>
    );
  }

  return (
    <div className="state">
      <strong>Connect to Simkl</strong>
      <p>Your watch history stays in your Simkl account. This app reads and writes it.</p>
      {error !== null && <p>{error}</p>}
      <button type="button" onClick={onSignIn}>
        {pairing ? "Starting…" : "Sign in"}
      </button>
    </div>
  );
}
